import { IdentityApi } from 'api/IdentityApi';
import { useState } from 'react';
import { Button, Form, FormGroup, Modal, Spinner } from 'react-bootstrap';
import { ClipboardXFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

type PropTypes = {
  accessToken: string | null;
  getInquiry: () => Promise<void>;
};

export const ExternalSellerDeclineModal = ({
  accessToken,
  getInquiry,
}: PropTypes) => {
  const [show, setShow] = useState<boolean>(false);
  const [comment, setComment] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { t } = useTranslation('components');

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleDecline = async () => {
    setIsLoading(true);
    if (accessToken) {
      await IdentityApi.declineExternalSellerInquiry(accessToken, { comment });
      toast.success(t('documents.inf_InquiryDeclined'));

      await getInquiry();
    }

    handleClose();

    setIsLoading(false);
  };

  return (
    <>
      <Button
        disabled={isLoading}
        onClick={handleShow}
        className='btn-outline-danger d-flex align-items-center'
      >
        <ClipboardXFill className='icon-ez-red me-1' />{' '}
        {t('common.btn_Decline')}
      </Button>

      <Modal size='sm' show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{t('documents.hd_DeclineInquiry')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('documents.inf_DeclineInquiry')}</p>

          <FormGroup>
            <Form.Label>{t('documents.lbl_DeclineInquiry')}</Form.Label>
            <Form.Control
              as='textarea'
              onChange={(event) => setComment(event.target.value)}
            />
          </FormGroup>
        </Modal.Body>

        <Modal.Footer>
          <Button
            disabled={isLoading}
            onClick={handleClose}
            variant='secondary'
          >
            {t('common.btn_Cancel')}
          </Button>
          <Button
            disabled={isLoading || comment === ''}
            onClick={handleDecline}
            variant='danger'
          >
            {t('common.btn_Ok')}{' '}
            {isLoading && <Spinner animation='border' size='sm' />}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
